var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',_vm._b({on:{"click":_vm.topUpAccount}},'v-btn',_vm.buttonProps,false),[_vm._v("\n  "+_vm._s(_vm.ctaLabel)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }